export default __webpack_public_path__ + "static/media/age_1_bubbles.15457b28.svg";